var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3F3F3;}\n\t.st1{fill:#E1E1E1;}\n\t.st2{fill:#FD8369;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#DE8E68;}\n\t.st5{fill:#6FC9CE;}\n\t.st6{fill:#FEBF92;}\n\t.st7{fill:#FED892;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.95;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#000000;stroke-width:1.0746;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:#74D5DE;}\n\t.st11{fill:#FECC92;}\n\t.st12{fill:#D38466;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 43,
    className: "st0",
    width: 727.7,
    height: 717.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 43,
    className: "st1",
    width: 727.7,
    height: 54.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 148.3,
    cy: 71,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 176,
    cy: 71,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 203.7,
    cy: 71,
    r: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 137.4,
    className: "st3",
    width: 290.9,
    height: 157.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 332.4,
    className: "st3",
    width: 290.9,
    height: 157.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.2,
    y: 332.4,
    className: "st3",
    width: 290.9,
    height: 339.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.9,
    y: 148.8,
    className: "st1",
    width: 399.4,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.9,
    y: 191.7,
    className: "st1",
    width: 399.4,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.9,
    y: 234.6,
    className: "st1",
    width: 399.4,
    height: 15.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.9,
    y: 277.5,
    className: "st1",
    width: 399.4,
    height: 15.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Foreground"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689.9,
    y: 756.2,
    className: "st4",
    width: 15.3,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.2,
    y: 854.2,
    className: "st4",
    width: 15.3,
    height: 23.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802.2,541.5c-18.5,0-101.1,82.1-108.3,95.9c-7.2,13.8-5.1,121.9-5.1,121.9l17.8,3.4L735.5,662 c12.6-1.5,65.6-12.9,93-35c27.4-22.2-2.6-71.7-2.6-71.7L802.2,541.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M771.3,430c-9.1,8.1-27.3,28.4-28.8,31c-4.6-2.2-52.5-27.4-56.1-29c-3.6-1.6-11.2-14.3-13.8-14.3 c-1.5,0-2.9,2.9-2.9,4.9c0,3.4,1.6,6,2.6,7.1c-3.4-0.5-33.4-2.8-33.4-0.8c0,5.2,33.6,12.1,36.2,13.5c2.6,1.4,57.3,52,76.3,52 c7.4,0,40.1-22.2,40.1-24.6c3.1-2.1,7.9-5.2,7.9-5.2v-17.6l-11.4-8.3C788,438.6,773.1,428.4,771.3,430z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M770.1,424.2c2-16.2,39.3-53,56.4-36.6c14.9,14.3-12.1,65.4-19,67.4C799.7,455.8,769.6,435.2,770.1,424.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M883.9,390.5c19-8,45.6,36,42.6,52c0,7-39,22-45,18S864.9,398.5,883.9,390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M801.7,449.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M854.7,340.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M807.3,548.6l62.8,305.5h16.1l5.7-272.5c0-4.7-0.4-34.3-0.4-38.1C873.3,548.8,834.5,553,807.3,548.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "870.2,877.4 885.5,877.4 885.5,894 843.3,894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "689.9,779.4 705.2,779.4 705.2,796 663,796  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 796,
    className: "st2",
    width: 182.1,
    height: 106.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "140.7,908.4 70.4,907.6 45.8,817.3 163.7,817.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M842.3,367c47,0,63.4,39.1,63.4,51.8c0,12.7-14.7,90.2-14.1,124.7c0.1,5.7-84.3,10.8-95.8,2.5 C790.4,542.1,778.8,367,842.3,367z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M926.5,442.5c13.3,20.4,12.5,67.4,12.5,74.5c0,7.1-49.6,70.9-53.9,70.9c-2.6-2.6-9.8-10.5-9.8-12.9 c2.3-4.2,31.8-68.7,37.1-73.3c-2.4-2.9-23.5-36-24.4-41.5C906.5,457.1,924.4,449.3,926.5,442.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M926.5,442.5c3-16-21.3-62.4-42.6-52c-18.5,9.1-8.4,66-2.4,70C888.7,463.6,923.7,453.1,926.5,442.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M830.3,357.4c-1,3.1-1.5,12.7-0.4,17c0.1,0.2,20,1.7,22.2-1.8c0.1-2.9,4.9-28.7,11.4-36.7 c0.6-0.9-0.7-3.4-0.7-3.4l-23.1,9.6L830.3,357.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M860.2,334.7c1.5,2,3.4,2.9,5.1,2.9c3.8,0,12.6-3.5,12.6-16c0-9-8.8-13.6-8.8-17.9c0-4.1,1.1-4.2,1.1-7.6 c0-1.7-1.7-7.3-7-7.3c-3,0-4.1,2.5-7.1,2.5c-3.3,0-6.3-6.4-11.3-6.4c-3.4,0-6.6,3.2-10.2,3.2c-4.1,0-6.9-6.1-12.6-6.1 c-5.9,0-8,5.3-10.3,5.3c-2.9,0-3.4-0.8-6.3-0.8c-1.8,0-7.3,3.2-7.3,9c0,4.1,1.7,10.8,10.2,10.8c5,0,7.8,7.9,12.2,7.9 c1.7,0,3.2-1.4,3.6-0.7c1.7,3,5.2,11.2,5.2,11.2l15.9,8.9L860.2,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M856.7,330.6c0,1.4-0.5,1.7-2.6,1.7c-1,0-2.4-1.3-2.4-2.7c0-3.3,2.4-4,2.4-8.3c0-7.3-19.1-11.1-25.8-14.9l0,0 c-2.4,2.4-4.1,5.5-4.8,9l-4.3,22.1c-1.9,9.6,4.4,18.9,13.9,20.8s18.9-4.4,20.8-13.9l0.7-3.8l0,0c0.4,0.1,0.8,0.2,1.1,0.2 c2.5,0,4.4-2.3,4.4-5.1C860.3,333.1,856.7,328.5,856.7,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.8,781.9C94.5,646,44.8,574.7,38.5,577.4c-8.9,3.9-11.5,80.2,4.4,159c0.4,0,0.7-0.1,1.1-0.1 c4.6,0,8.3,3.7,8.3,8.3c0,1.4-0.3,2.7-0.9,3.8c2.7,1.4,4.6,4.2,4.6,7.4c0,4-2.9,7.4-6.7,8.2c4.7,18.2,10.6,36.2,17.6,52.9 c3.6,0,44,0,44,0S117.8,801.7,114.8,781.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M232.3,637.8c-12.3,0-25.5,35.4-40.1,35.4c-3.2,0-5.3-3.5-5.3-6.8c0-3.2,10.1-38.4,10.1-55.5 c0-1.5-0.1-3.1-0.3-4.7c-1.6,1-3.6,1.6-5.6,1.6c-6,0-10.9-4.9-10.9-10.9c0-5.3,3.7-9.6,8.7-10.7c-5.1-6.5-12.6-11.1-22.8-11.1 c-12.9,0-31.1,11.5-31.1,29.3c0,5,1.5,17.7,1.5,29.2c0,65.2-51.1,75-51.1,147.2c0,15.2,8.4,31.9,10.9,36c0,0,42.8,0.5,46.9,0.5 s37.4-55.6,41.2-61.5c14.5-22.4,62.7-47,62.7-100.5C247.1,647.8,244.4,637.8,232.3,637.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.672a6c86ca8ef15e4c8aca79a5d44c7e.svg";
export { ForwardRef as ReactComponent };